<div class="border-b border-slate-200 px-5 py-4">
  <div class="flex items-center justify-between">
    <h4 class="text-lg font-semibold text-slate-900" id="modal-basic-title">
      Eliminar empresa
    </h4>
    <button
      type="button"
      class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="modal().dismiss('Cross click')"
    >
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>
<div class="space-y-2 px-5 py-4 text-sm text-slate-700">
  <p>¿Está seguro que desea eliminar esta empresa?</p>
  <p class="font-semibold text-slate-900">{{ empresa()?.nombre }}</p>
  <p>
    Esta acción eliminará todos los datos asociados a la empresa, incluyendo
    usuarios y licencias.
  </p>
  <p class="text-xs text-slate-500">Esta acción no se puede deshacer.</p>
</div>
<div class="flex justify-end gap-2 border-t border-slate-200 px-5 py-4">
  <button
    type="button"
    class="rounded-lg bg-red-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-red-500"
    (click)="confirmDelete()"
  >
    Eliminar
  </button>
  <button
    type="button"
    class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
    (click)="modal().dismiss('Cross click')"
  >
    Cancelar
  </button>
</div>
